import { CheckCircle, FolderOpen, MagnifyingGlass } from "@phosphor-icons/react";
import React, { useEffect, useState } from "react";

export default function SignalList() {
  let [signals, setSignals] = useState([]);

  useEffect(() => {
    const storedDetails = JSON.parse(localStorage.getItem("userDetails"));
    setSignals(storedDetails.tradesTaken);
  }, []);

  if (signals.length === 0) {
    return (
      <div className="w-full h-full pt-10">
        <div className="w-full h-[50%] ">
          <nav className="border-1 flex justify-between w-full p-4 border border-gray-400 rounded-tl-md rounded-tr-md ">
            <p>All Signals</p>
            <div className="relative">
              <input
                type="text"
                placeholder="Search ID or Title"
                className="h-8 p-2 text-black pr-[2.2rem]"
              />
              <button className="bg-green-400 rounded absolute top-0 right-0">
                <MagnifyingGlass size={32} />
              </button>
            </div>
          </nav>
          <span className="flex justify-center items-center  flex-col gap-2 border border-t-0 border-gray-400 h-full">
            <FolderOpen size={72} />
            <p>No Signal Found</p>
          </span>
        </div>
      </div>
    );
  } else {
    return (
      <div className="w-full h-full pt-10">
        <div className="w-full h-fit ">
          <nav className="border-1 flex justify-between w-full p-4 border border-gray-400 rounded-tl-md rounded-tr-md ">
            <p>All Signals</p>
            <div className="relative">
              <input
                type="text"
                placeholder="Search ID or Title"
                className="h-8 p-2 text-black pr-[2.2rem] rounded-tr-full rounded-br-full "
              />
              <button className="bg-green-400 rounded absolute top-0 right-0">
                <MagnifyingGlass size={32} />
              </button>
            </div>
          </nav>

          {/* 
id
"d4a5e472-3776-4a9b-9cbc-01763fa5d5f9"
symbol
"ETH/USDT:USDT"
order Type
"market"
side
"buy"
takeProfitPrice
null
stoplossPrice
null
Price
"" */}
          <div className="w-full pt-50 border-t-0  border border-gray-400 pb-2 lg:overflow-hidden overflow-scroll px-7  ">
            <table className="w-full h-full">
              <tr className="flex justify-between w-full mb-3">
                <th className="text-center w-[7.7rem]">ID</th>
                <th className="text-center w-[7.7rem]">Signal Provider</th>
                <th className="text-center w-[7.7rem]">Symbol</th>
                <th className="text-center w-[7.7rem]">Type</th>
                <th className="text-center w-[7.7rem]">TakeProfit</th>
                <th className="text-center w-[7.7rem]">Stoploss</th>
                <th className="text-center w-[7.7rem]">Trade Success</th>
              </tr>
              {signals.map((items,idx) => (
                <tr className="flex justify-between w-full items-center mb-2">
                  <td className="text-xs truncate w-[7.7rem]" key={idx}>{items.id}</td>
                  <td className="text-center self-center w-[7.7rem]" key={idx}>
                   stranger fx
                  </td>
                  <td className="w-[7.7rem] text-center self-center" key={idx}>
                    {items.symbol}
                  </td>
                  <td className="w-[7.7rem] text-center self-center" key={idx}>
                    {items.side}
                  </td>
                  <td className="w-[7.7rem] text-center" key={idx}>
                    {items.takeProfitPrice}
                  </td>
                  <td className="w-[7.7rem] text-center" key={idx}>
                    {items.stoplossPrice}
                  </td>
                  <td className="w-[7.7rem] text-center self-center" key={idx}><CheckCircle size={22} className="m-auto" color="#90EE90"  weight="fill" />
                  {/* <XCircle size={22} className="m-auto" color="#90EE90"  weight="fill" /> */}
              </td>
                </tr>
              ))}
            </table>
          </div>
        </div>
      </div>
    );
  }
}
